import React from "react";
import StarRating from "./StarRating";

const ProductCard = ({ product }) => {
  if (!product) return null;

  return (
    <div className="mt-2">
      <img
        src={`/${product.image}`}
        alt={product.title}
        className="mx-auto mb-4 rounded-lg"
      />
      <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">
        {product.title}
      </h3>
      <StarRating rating={product.rating || 5} />
      <div className="mb-2">
        <div className="space-y-1 text-sm font-medium">
          <div className="text-gray-500">
            Price: <span className="line-through">{product.mrp}</span>{" "}
            <span className="text-red-700 text-base">{product.price}</span>
          </div>
          <div className="text-red-600">
            You Save: {product.savings} ({product.discount})
          </div>
          <div className="text-black font-medium">Free Delivery</div>
        </div>
      </div>
      <a
        href={`/products/${product.str}`}
        className="mt-4 inline-block px-4 py-2 w-full bg-pink-500 text-white text-xs font-medium rounded hover:bg-gray-800 transition"
      >
        View Details
      </a>
    </div>
  );
};

export default ProductCard;
